var map = {
	"./Pentagon.svg": "2c2e",
	"./Rectangle.svg": "9d53",
	"./bottom-round-rectangle.svg": "2fc7",
	"./concave-hexagon.svg": "2313",
	"./diamond.svg": "d7ff",
	"./ellipse.svg": "399d",
	"./octagon.svg": "46cb",
	"./round-rectangle.svg": "afd1",
	"./round-tag.svg": "55a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a77f";